export const environment = {
    production: false,
    estado: "Staging! 🙃",
    url_api: "https://test-api.holajarvis.com/api/v1",
    HK_API_KEY: 'qJHWUZJpn75uaR62ml1Fyo20EaveMmHo',
    SOCKET_IO: 'https://socket.holajarvis.com'
};